import { z } from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { AddressFormSchema } from '../../AddressService/schemas';

const ResponsibleRecognitionFormSchemaWithAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  recognitionGroupIds: z.number().array(),
  facialControllerIds: z.number().array(),
  isAddress: z.literal(true),
  address: AddressFormSchema,
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  email: z.string().optional(),
  gender: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
  password: z.string().optional(),
  isEnabledEditionPassword: z.boolean().optional(),
  repeatPassword: z.string().optional(),
  telegramId: z.string().optional(),
  carPlates: z.string().array().default([]),
  vehicleTags: z.string().array().default([]),
  deviceToken: z.string().nullish(),
  studentIds: z.array(z.number()).default([]),
  uc: z.string().array().nullish(),
});

const ResponsibleRecognitionFormSchemaWithoutAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  deviceToken: z.string().nullish(),
  recognitionGroupIds: z.number().array().nullable(),
  facialControllerIds: z.number().array().nullable(),
  deviceGroupIds: z.number().array().nullable(),
  isAddress: z.literal(false),
  address: z.null(),
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  email: z.string().optional(),
  gender: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
  password: z.string().optional(),
  repeatPassword: z.string().optional(),
  isEnabledEditionPassword: z.boolean().optional(),
  telegramId: z.string().optional(),
  carPlates: z.string().array().default([]),
  vehicleTags: z.string().array().default([]),
  studentIds: z.number().array(),
  tempStudentsIds: z.number().array(),
  classId: z.number().array().nullish(),
  uc: z.string().array().nullish(),
  type: z.string().nullish(),
  freePass: z.boolean().nullish(),

});

export const ResponsibleRecognitionFormSchema = z
  .discriminatedUnion('isAddress', [
    ResponsibleRecognitionFormSchemaWithAddress,
    ResponsibleRecognitionFormSchemaWithoutAddress,
  ])
  .superRefine((data, ctx) => {
    const isCreating = !data.id;
    const isEditingPassword = data.isEnabledEditionPassword;

    if (isCreating) {
      if (!data.password || data.password.trim().length === 0) {
        ctx.addIssue({
          path: ['password'],
          code: z.ZodIssueCode.custom,
          message: 'Campo obrigatório.',
        });
        ctx.addIssue({
          path: ['repeatPassword'],
          code: z.ZodIssueCode.custom,
          message: 'Campo obrigatório.',
        });
        return;
      }
    }

    if (data.password && data.password.length > 0) {
      if (data.password.length < 8) {
        ctx.addIssue({
          path: ['password'],
          code: z.ZodIssueCode.custom,
          message: 'A senha deve conter no mínimo 8 caracteres',
        });
      }

      if (isCreating || isEditingPassword) {
        if (data.repeatPassword !== data.password) {
          ctx.addIssue({
            path: ['repeatPassword'],
            code: z.ZodIssueCode.custom,
            message: 'As senhas não são iguais.',
          });
        }
      }
    }

    if (data.validUntil) {
      const validUntil = new Date(data.validUntil);
      const now = new Date();

      now.setHours(0, 0, 0, 0);
      validUntil.setHours(0, 0, 0, 0); 

      if (validUntil.getTime() < now.getTime()) {
        ctx.addIssue({
          path: ['validUntil'],
          code: z.ZodIssueCode.custom,
          message: 'A data de validade da face não pode ser anterior à data atual.',
        });
      }
    }
  });
